<template>
  <div>
    <div class="limiter" v-if="id">
      <div class="image">
        <img src="../assets/logo/logo.png" alt="Logo">
      </div>
      <div class="container-login100">
        <div class="wrap-login100">

          <!-- Display username -->
          <div v-if="username" class="username-display">
            <p>Welcome, {{ username }}! </p>
            <!--            <p>Current state: {{ state }}</p>-->
          </div>

          <form class="login100-form validate-form" @submit.prevent="submit">
            <h1>
              <span class="login100-form-title">
                Enter {{ priceType }} <span v-if="priceType === 'Weighed'"> kg</span>
              </span>
            </h1>

            <div class="form-group file-input-container">
              <input
                  id="file-nrcPassport"
                  class="input100"
                  type="file"
                  name="image"
                  @change="handleFileChange($event, 'file')"
                  accept=".pdf,image/*"
                  required
              >
              <label for="file-nrcPassport" class="btn-file-input">{{ image || 'Picture of Package' }}</label>
            </div>

            <div class="form-group">
              <label for="units">{{ priceType }}</label>
              <input
                  id="units"
                  v-model.number="form.units"
                  class="input100"
                  :step="stepValue"
                  type="number"
                  name="units"
                  :placeholder="priceType"
                  required
              >
            </div>

            <div class="form-group">
              <label>Total Amount</label>
              <p>{{ totalAmount }}</p>
            </div>

            <p v-if="!form.fileBase64"> Please take a picture of the package </p>

            <button type="submit" class="login100-form-btn" v-else>
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CourierRegistration',
  data() {
    return {
      id: this.$route.query.id,
      username: this.$route.query.userName || 'Guest',
      type: '',
      form: {
        units: '',
        file: null,
        fileBase64: '',
      },
      image: '',
      priceType: this.$route.query.priceType,
      price: Number(this.$route.query.price) || 0,
    };
  },

  computed: {
    totalAmount() {
      const units = parseFloat(this.form.units) || 0;
      const price = this.price;
      return (units * price).toFixed(2);
    },
    stepValue(){
      return this.priceType === 'Weighed'?`0.001`:`1`;
    }
  },
  watch: {
    '$route.query.id': function(newId) {
      this.id = newId;
    },
    '$route.query.priceType': function(newPriceType) {
      this.priceType = newPriceType;
    },
    '$route.query.price': function(newPrice) {
      this.price = Number(newPrice) || 0;
    }
  },
  methods: {
    async getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },

    async handleFileChange(event, field) {
      const file = event.target.files[0];
      if (file) {
        this.form[field] = file;
        try {
          this.form.fileBase64 = await this.getBase64(file);
          this.image = file.name;
        } catch (error) {
          console.log(error);
        }
      }
    },

    async submit() {
      if (!this.validateForm()) {
        responses.showInfo('Please enter a valid number of units.')
        return;
      }
      const payload = {
        dispId: this.id,
        username: this.username,
        type: 'TRANSIT',
        status: 'Courier',
        amount: this.totalAmount,
        imageBase64Str: this.form.fileBase64,
      };
      this.$store.commit('setLoadingState', true);
      return this.$store.dispatch('updateDispatchDetails', payload)
          .then(() => {
            responses.showSuccess(`Successfully updated the state`)
            this.resetForm();
            this.logout();
          })
          .finally(()=> this.$store.commit('setLoadingState', false));
    },

    logout() {
      this.$store.commit('clearUserData');
      localStorage.removeItem('user');
      this.$router.push(`/login?id=${this.id}`);
    },

    validateForm() {
      return this.form.units && !isNaN(this.form.units) && Number(this.form.units) > 0;
    },

    resetForm() {
      this.form.units = '';
      this.form.file = null;
      this.form.fileBase64 = '';
    }
  }
}
</script>
